import nlp from '../assests/speech.jpg'
import ware from '../assests/ware.jpg'
import dsa from '../assests/datascience.jpg'
import ptn from '../assests/patterns.jpg'
import viz from '../assests/dash.jpg'
import team from '../assests/team.jpg'
import bot from '../assests/bot.jpg'

const ProductData=[
    {
        title:"Avoices (African Voices)",
        img:nlp,
        description:"Transform your business with Africa's #1 Multilingual AI Platform. Achieve 95% accuracy in audio/video transcription, document translation, and text summarization across 10+ African languages. Reduce translation costs by 60% while preserving cultural authenticity.",
        benefits: ["95% accuracy rate", "60% cost reduction", "10+ African languages", "Real-time processing"],
        useCases: ["Government communications", "Educational content", "Business documents", "Media transcription"],
        link: "https://voices.phosaico.com/"
    },
    {
        title:"PhosAI Agents",
        img:bot,
        description:"Create custom AI assistants in 10 African languages in under 5 minutes. Boost customer engagement by 300% with voice-to-voice conversations that understand local accents and cultural context. Perfect for customer service, sales, and support automation.",
        benefits: ["300% engagement boost", "5-minute setup", "10 African languages", "Voice & text support"],
        useCases: ["Customer service", "Sales automation", "Support systems", "Educational bots"],
        link: "https://voices.phosaico.com/"
    },
    {
        title:"Hotel Voice Assistant",
        img:team,
        description:"Revolutionize guest experience with AI-powered voice assistants. Handle 80% of guest inquiries automatically, reduce check-in time by 50%, and increase guest satisfaction scores. Available in multiple languages with customizable hotel-specific responses.",
        benefits: ["80% automation", "50% faster check-in", "Multi-language support", "24/7 availability"],
        useCases: ["Hotel reservations", "Conference bookings", "Room service", "Guest support"]
    },
    {
        title:"Agricultural Advisory AI",
        img:ptn,
        description:"Increase crop yields by 30% with AI-powered farming guidance in local languages. Provide real-time weather alerts, pest control advice, and market price updates to farmers. Accessible via voice, text, and mobile apps for maximum reach.",
        benefits: ["30% yield increase", "Real-time alerts", "Local language support", "Mobile accessibility"],
        useCases: ["Crop management", "Weather monitoring", "Pest control", "Market insights"]
    },
    {
        title:"PHOSAI Pod",
        img:ware,
        description:"Break down language barriers instantly with our real-time translation device. Support 15+ languages including major Ugandan dialects. Perfect for tourism, healthcare, and business meetings. Achieve 90% translation accuracy in real-time conversations.",
        benefits: ["Real-time translation", "15+ languages", "90% accuracy", "Portable device"],
        useCases: ["Tourism", "Healthcare", "Business meetings", "Emergency services"],
        link: "https://voices.phosaico.com/"
    },
    {
        title:"Cortex AI",
        img:viz,
        description:"Transform your brand strategy with AI-powered media intelligence. Analyze radio and TV broadcasts in real-time to understand audience sentiment, track ad performance, and identify trending topics. Get actionable insights that drive 40% better marketing decisions.",
        benefits: ["Real-time analysis", "40% better decisions", "Sentiment tracking", "Ad performance"],
        useCases: ["Brand monitoring", "Ad tracking", "Market research", "Competitive analysis"]
    },
    {
        title:"PhosOCR",
        img:dsa,
        description:"Automate data entry with 99% accuracy using AI-powered document processing. Reduce manual data entry by 90% and process 1000+ documents per hour. Support for receipts, forms, ID cards, and handwritten text in multiple languages.",
        benefits: ["99% accuracy", "90% time savings", "1000+ docs/hour", "Multi-language support"],
        useCases: ["Banking", "Healthcare", "Government", "Retail"]
    },
    {
        title:"AfriData Elite",
        img:viz,
        description:"Global marketplace for high-quality multi-modal datasets. Powering the next generation of AI with African linguistic and visual intelligence. Access curated datasets for training robust machine learning models.",
        benefits: ["Multi-modal datasets", "High-quality curation", "Linguistic intelligence", "Visual intelligence"],
        useCases: ["AI Research", "Model Training", "Data Mining", "Linguistic Studies"],
        link: "https://afridata.phosaico.com/"
    },
    {
        title:"CarryiT",
        img:ware,
        description:"The ultimate logistics platform for transferring and delivering commodities across Uganda. Seamlessly hire trucks, track shipments in real-time, and optimize your supply chain with our intelligent delivery network.",
        benefits: ["Commodity transfer", "Truck hiring", "Real-time tracking", "Supply chain optimization"],
        useCases: ["Agro-logistics", "Construction materials", "Wholesale distribution", "Fleet management"],
        link: "https://carryitug.com/"
    },
    {
        title:"Easy Rentals",
        img:bot,
        description:"Comprehensive real estate platform and property management system. Simplify property listings, tenant management, and rent collection with an intuitive interface designed for property owners and agents.",
        benefits: ["Property management", "Tenant tracking", "Rent collection", "Listing optimization"],
        useCases: ["Apartment rentals", "Commercial properties", "Property agencies", "Landlord support"],
        link: "https://carryitug.com/"
    },
    {
        title:"Brand Pulse",
        img:viz,
        description:"Advanced brand management and sentiment analysis platform. Monitor your brand's reputation in real-time across TikTok, X, Facebook, LinkedIn, and YouTube. Gain deep insights into customer sentiment and market trends to drive brand growth.",
        benefits: ["Sentiment analysis", "Multi-platform monitoring", "Real-time reputation tracking", "Trend identification"],
        useCases: ["Brand reputation", "Market research", "Crisis management", "Customer feedback analysis"]
    }
]

export default ProductData